<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de cadastros consistentes">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/atencao-basica/relatorio-cadastro-consistente/List'

export default {
    components: { List },
}
</script>
